/**
 * types.ts — Tipos compartidos del paso P3 Coteja
 *
 * UID-03a | Fase 3 | feat/step3-coteja
 * @date 2026-03-06
 */

import type { InfrastructureType as _InfrastructureType } from '@/types/infrastructure';

// ─── Urgencia ─────────────────────────────────────────────────────────────────

export type UrgenciaNivel = 'alta' | 'media' | 'baja' | 'ninguna';

export const URGENCIA_CONFIG: Record<UrgenciaNivel, { label: string; color: string }> = {
  alta:    { label: 'Alta',         color: '#EF4444' },
  media:   { label: 'Media',        color: '#F97316' },
  baja:    { label: 'Baja',         color: '#FBBF24' },
  ninguna: { label: 'Sin urgencia', color: '#71717a' },
};

// ─── Vista / filtro activo ─────────────────────────────────────────────────────

export type VistaFiltro = 'todos' | 'ausentes' | 'incluidos' | 'sobrantes';

// ─── Candidato (coord alternativa propuesta) ──────────────────────────────────

export interface Candidato {
  id: string;
  nombre: string;
  x: number;
  y: number;
  fuente: string;
  score: number;
}
